document.addEventListener('DOMContentLoaded', () => {
	const currentColor = document.querySelector('[data-current-color]');
	if (currentColor) {
		const originalColor = currentColor.textContent;
		const colorSwatches = document.querySelectorAll('[data-color-swatch]');
		colorSwatches.forEach(colorSwatch => colorSwatch.addEventListener('mouseenter', () => {
			currentColor.textContent = colorSwatch.dataset.colorSwatch;
		}));
		colorSwatches.forEach(colorSwatch => colorSwatch.addEventListener('mouseleave', () => {
			currentColor.textContent = currentColor.dataset.currentColor;
		}));
	}
})

// window.addEventListener('scroll', function() {
//   const productAccordions = document.querySelector('.Product__Accordions');
//   const charts = document.querySelectorAll('.chart');

//   charts.forEach(function(chart) {
//     // get the top of the section and the bottom of the chart
//     const top = productAccordions.getBoundingClientRect().top;
//     const bottom = chart.getBoundingClientRect().bottom;

//     // check if the chart is visible
//     if (top < window.innerHeight && bottom > 0) {
//       chart.classList.add('active');
//     } else {
//       chart.classList.remove('active');
//     }
//   });
// });


// window.addEventListener('load', function() {
//   const productAccordions = document.querySelector('.Product__Accordions');
//   const charts = document.querySelectorAll('.chart');

//   charts.forEach(function(chart) {
//     // get the top of the section and the bottom of the chart
//     const top = productAccordions.getBoundingClientRect().top;
//     const bottom = chart.getBoundingClientRect().bottom;

//     // check if the chart is visible
//     if (top < window.innerHeight && bottom > 0) {
//       chart.classList.add('active');
//     } else {
//       chart.classList.remove('active');
//     }
//   });
// });

